<template>
  <tr>
    <td colspan="3" class="product-cell">    
      <v-select v-model="selectedProduct" @input="setRate" v-if="productName === ''" label="product_name" :options="productList"></v-select>
      <span v-if="productName !== ''">{{productName}}</span>
    </td>
    <td colspan="1" class="qty-cell">
      <input v-model="quantity" @change="updateTotal()">
    </td>
    <td colspan="1" class="cost-cell">
      <!-- <div class="input-group">
        <span class="input-group-addon"><i class="fa fa-rupee"></i></span> -->
        <input class="ml-2 form-control" v-model="price" @change="updateTotal()">
      <!-- </div> -->
    </td>
    <td colspan="1" class="total-cell">
      <!-- <div class="input-group cost-cell">
        <span class="input-group-addon"><i class="fa fa-rupee"></i></span> -->
        <input class="ml-2 form-control" v-model="subTotal" readonly>
      <!-- </div> -->
    </td>
    <td colspan="1" class="icon-wrap">
      <b-icon-trash variant="danger" @click="removeRow()"/>
    </td>
  </tr>
</template>

<script>
import { BIconTrash } from 'bootstrap-vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
export default {
  name: 'ProductLine',
  data () {
    return {
      selectedProduct: null,
      productName: this.product.product_name,
      productId: this.product.product_id,
      quantity: this.product.quantity,
      price: this.product.price,
      uom: this.product.uom,
      subTotal: this.product.sub_total,
      emited: false
    }
  },
  components: {
    BIconTrash,
    vSelect
  },
  props: {
    product: Object,
    productList: Array,
    partnerId: Array,
    index: Number
  },
  watch: {
    product(newVal) {
      this.productName = newVal.product_name
      this.productId = newVal.product_id
      this.quantity = newVal.quantity
      this.price = newVal.price
      this.uom = newVal.uom
      this.subTotal = newVal.sub_total
    }
  },
  computed: {
    getLink: function () {
      if (this.isActive) {
        return 'tooth' + this.id + 'h.png'
      } else {
        return 'tooth' + this.id + '.png'
      }
    }
  },
  methods: {
    setRate: function (value) {
      this.price = value.price;
    },
    removeRow: function () {
      this.$emit('remove-row', this.product)
    },
    updateTotal: function () {
      console.log('updateTotal', this.subTotal)
      if (this.price != '' && this.quantity != '') {
        this.subTotal = this.price * this.quantity
      }
      else {
        this.subTotal = 0
      }
      console.log('updateTotal', this.subTotal)
      if (this.selectedProduct) {
        this.productId = this.selectedProduct.product_id
        this.productName = this.selectedProduct.product_name
      }
      this.$emit('update-total', { product_id: this.productId, quantity: this.quantity, price: this.price, uom: this.uom, sub_total: this.subTotal, key: this.index, product_name: this.productName })
      this.emited = true
    }
  }
}
</script>

<style scoped>
image {
    cursor: pointer;
}
table td input{
  padding: 2px;
  height: 26px;
}
table td.icon-wrap{
  vertical-align: middle;
  cursor: pointer;
}
.qty-cell input{
  width: 50px
}
.cost-cell input{
  width: 80px
}
</style>
